import { createSlice } from "@reduxjs/toolkit";
import { createBillingStatement, fetchBillingStatement, fetchBillingStatements, fetchBillingSummary, recordPayment, sendBillingStatement } from "state/action/billing_statement";

const billingStatementSlice = createSlice({
  name: "billingStatement",
  initialState: {
    statements: [],
    currentStatement: null,
    summary: null,
    loading: false,
    error: null,
    metadata: null,
  },
  reducers: {
    clearCurrentStatement: (state) => {
      state.currentStatement = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchBillingStatements.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBillingStatements.fulfilled, (state, action) => {
        state.loading = false;
        state.statements = action.payload.data;
        state.metadata = action.payload.metadata;
      })
      .addCase(fetchBillingStatements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch one
      .addCase(fetchBillingStatement.fulfilled, (state, action) => {
        state.currentStatement = action.payload.data;
      })
      // Create
      .addCase(createBillingStatement.fulfilled, (state, action) => {
        state.statements.unshift(action.payload.data);
      })
      // Send
      .addCase(sendBillingStatement.fulfilled, (state, action) => {
        const index = state.statements.findIndex(
          (s) => s._id === action.payload.data._id,
        );
        if (index !== -1) {
          state.statements[index] = action.payload.data;
        }
        if (state.currentStatement?._id === action.payload.data._id) {
          state.currentStatement = action.payload.data;
        }
      })
      // Record payment
      .addCase(recordPayment.fulfilled, (state, action) => {
        const index = state.statements.findIndex(
          (s) => s._id === action.payload.data._id,
        );
        if (index !== -1) {
          state.statements[index] = action.payload.data;
        }
        if (state.currentStatement?._id === action.payload.data._id) {
          state.currentStatement = action.payload.data;
        }
      })
      // Fetch summary
      .addCase(fetchBillingSummary.fulfilled, (state, action) => {
        state.summary = action.payload.data;
      });
  },
});

export const { clearCurrentStatement } = billingStatementSlice.actions;
export default billingStatementSlice.reducer;
